import $api from "http";

export async function postTabel(formdata) {
    return $api.post(`/tabel/`, formdata ,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }); 
  }

  

  export async function getTabel(data) {
    return $api.get(`/mytabel/`, data);
  }
  export async function getTabelLast(data) {
    return $api.get(`/mytabellast/`, data);
  }
  
  export async function getQrInfo(data) {
    return $api.get(`/qr_organization/`, data);
  }
  